export const LIFE_CYCLE_EVENTS = {
  CREATED: 'created',
  FIRST_UPDATE_COMPLETED: 'first-update-completed',
  DESTROYED: 'destroyed',
  MODIFIED: 'modified',
} as const;
